/**
 * @license lucide v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

const GitMergeConflict = [
  ["path", { d: "M12 6h4a2 2 0 0 1 2 2v7" }],
  ["path", { d: "M6 12v9" }],
  ["path", { d: "M9 3 3 9" }],
  ["path", { d: "M9 9 3 3" }],
  ["circle", { cx: "18", cy: "18", r: "3" }]
];

export { GitMergeConflict as default };
//# sourceMappingURL=git-merge-conflict.js.map
